import React, { createContext, useState, useContext } from 'react';
import { apiLogin } from '../services/api';

// 1. Creamos el Contexto, que es como un contenedor de estado global.
const AuthContext = createContext(null);

// 2. Creamos el "Proveedor". Este componente envolverá toda nuestra aplicación
//    y le dará acceso al estado de autenticación.
export const AuthProvider = ({ children }) => {
  // 'useState' para guardar la información del usuario y el token.
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('user_token') || null);

  // Función de Login que usarán otros componentes.
  const login = async (username, password) => {
    try {
      const response = await apiLogin(username, password);
      if (response.data.token) {
        setUser(response.data.user);
        setToken(response.data.token);
        // Guardamos el token en el almacenamiento local del navegador
        // para que la sesión persista si el usuario recarga la página.
        localStorage.setItem('user_token', response.data.token);
        return true; // Devuelve true en caso de éxito.
      }
    } catch (error) {
      console.error("Fallo en el inicio de sesión:", error);
      // Lanza un nuevo error con un mensaje limpio para la UI.
      throw new Error(error.response?.data?.message || 'Credenciales inválidas');
    }
  };

  // Función de Logout.
  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user_token');
  };

  // Este es el "valor" que compartimos con toda la aplicación.
  const value = { user, token, login, logout };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// 3. Este es un "hook" personalizado. Es una forma simple para que otros
//    componentes puedan acceder al contexto sin escribir código repetitivo.
export const useAuth = () => {
  return useContext(AuthContext);
};
